import { render } from "./OfflineOrderDetail.vue?vue&type=template&id=039f02c6&scoped=true"
import script from "./OfflineOrderDetail.vue?vue&type=script&lang=js"
export * from "./OfflineOrderDetail.vue?vue&type=script&lang=js"

import "./OfflineOrderDetail.vue?vue&type=style&index=0&id=039f02c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039f02c6"]])

export default __exports__